import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box
} from '@mui/material';

interface DesignDetail {
  garmentPart: string;
  size: string;
  pieces: number;
  rate?: number;
  comments?: string;
}

interface JobWorkDesignDetailsProps {
  designDetails: DesignDetail[];
  hideRates?: boolean;
}

const JobWorkDesignDetails: React.FC<JobWorkDesignDetailsProps> = ({ designDetails, hideRates = false }) => {
  if (!designDetails || designDetails.length === 0) {
    return null;
  }

  // Calculate total amount (only relevant when rates are visible)
  const totalAmount = designDetails.reduce((sum, detail) => 
    sum + (detail.pieces * (detail.rate || 0)), 0
  );

  return (
    <Paper sx={{ p: 2, mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        Design Details
      </Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Garment Part</TableCell>
              <TableCell>Size</TableCell>
              <TableCell align="right">Pieces</TableCell>
              {!hideRates && <TableCell align="right">Rate</TableCell>}
              {!hideRates && <TableCell align="right">Amount</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {designDetails.map((detail, index) => (
              <TableRow key={index}>
                <TableCell>{detail.garmentPart}</TableCell>
                <TableCell>{detail.size}</TableCell>
                <TableCell align="right">{detail.pieces}</TableCell>
                {!hideRates && (
                  <TableCell align="right">₹{detail.rate?.toFixed(2) || '0.00'}</TableCell>
                )}
                {!hideRates && (
                  <TableCell align="right">₹{(detail.pieces * (detail.rate || 0)).toFixed(2)}</TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="subtitle1">
          Total Pieces: {designDetails.reduce((sum, detail) => sum + detail.pieces, 0)}
        </Typography>
        {!hideRates && (
          <Typography variant="subtitle1">
            Total Amount: ₹{totalAmount.toFixed(2)}
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default JobWorkDesignDetails; 